import { JBButton, JBTypography } from '@jbhi-fi/lanyard-ui';
import React, { ReactElement, ReactNode } from 'react';
import GoogleLogo from '../../../../../assets/svg/google-logo.svg';
import FacebookLogo from '../../../../../assets/svg/facebook-logo.svg';
import { styles } from './SocialLogins.css';
//@ts-ignore

export type SocialLoginsPropsType = {
  stacked?: boolean;
  heading?: string | ReactNode;
  emailLoginLabel?: string | ReactElement<typeof JBTypography>;
  handleClick: (event: React.MouseEvent, domainHint?: string) => void;
};

const Heading = ({ heading }: { heading: string | ReactNode }) => {
  if (React.isValidElement(heading)) return heading;
  return (
    <JBTypography type="p" margin="0">
      {heading}
    </JBTypography>
  );
};

const EmailLoginButton = ({
  emailLoginLabel,
  handleClick,
}: {
  emailLoginLabel: SocialLoginsPropsType['emailLoginLabel'];
  handleClick: SocialLoginsPropsType['handleClick'];
}) => {
  return (
    <div className={styles.loginButtonContainer}>
      <JBButton
        type="link"
        onClick={handleClick}
        label={React.isValidElement(emailLoginLabel) ? '' : 'Log in with your email'}
        customStyles={{ fontWeight: 'normal' }}
      >
        {React.isValidElement(emailLoginLabel) ? emailLoginLabel : null}
      </JBButton>
    </div>
  );
};

export const SocialLogins = ({
  stacked = false,
  handleClick,
  heading,
  emailLoginLabel,
}: SocialLoginsPropsType): JSX.Element => {
  return (
    <div className={styles.container}>
      {heading && <Heading heading={heading} />}
      <div className={styles.socialButtonsContainer({ stacked })}>
        <JBButton
          type="secondary"
          fullWidth
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleClick(event, 'google.com')}
          icon={<GoogleLogo />}
          iconPosition="left"
          label="Google"
        />
        <JBButton
          type="secondary"
          fullWidth
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleClick(event, 'facebook.com')}
          icon={<FacebookLogo />}
          iconPosition="left"
          label="Facebook"
        />
      </div>
      {emailLoginLabel && <EmailLoginButton emailLoginLabel={emailLoginLabel} handleClick={handleClick} />}
    </div>
  );
};
